import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';

import noCreditCard from 'shared/assets/images/articles/leasing/no-credit-card.png';
import security from 'shared/assets/images/articles/leasing/security.png';
import secureShield from 'shared/assets/images/articles/leasing/secure-shield.png';

import s from './LeasingGuaranty.css';

const items = [
  {
    image: noCreditCard,
    text: 'Без скрытых платежей и дополнительных комиссий',
  },
  {
    image: security,
    text: 'Несем ответственность за сохранность Ваших данных',
  },
  {
    image: secureShield,
    text: 'Соблюдаем законы о защите Ваших прав пользователя',
  },
];
class LeasingGuaranty extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  renderItem = (image, text) =>
    <div className={s.item} key={text}>
      <div className={s.icon}>
        <img alt={this.props.t(text)} src={image} width={40} height={40} />
      </div>
      <div className={s.text}>
        {this.props.t(text)}
      </div>
    </div>;

  render() {
    return (
      <div className={s.root}>
        <div className={s.title}>
          {this.props.t('Ответственность и гарантия безопасности')}
        </div>
        <div className={s.items}>
          {items.map(item => this.renderItem(item.image, item.text))}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(LeasingGuaranty));



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingGuaranty/LeasingGuaranty.js